import styles from './FilterChips.module.css';

interface FilterChipsProps<T extends string> {
  label: string;
  options: readonly T[];
  selected: Set<T>;
  onChange: (next: Set<T>) => void;
}

export function FilterChips<T extends string>({
  label,
  options,
  selected,
  onChange,
}: FilterChipsProps<T>) {
  const toggle = (opt: T) => {
    const next = new Set(selected);
    if (next.has(opt)) next.delete(opt);
    else next.add(opt);
    onChange(next);
  };
  return (
    <div className={styles.group} role="group" aria-label={label}>
      <span className={styles.label}>{label}</span>
      <div className={styles.row}>
        {options.map((opt) => (
          <button
            type="button"
            key={opt}
            onClick={() => toggle(opt)}
            aria-pressed={selected.has(opt)}
            className={[styles.chip, selected.has(opt) && styles.active]
              .filter(Boolean)
              .join(' ')}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}
